import { ApiServiceBase } from '../api-service-base';
import { RunningDashboard } from '../types';

export class RunningDashboardService extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  async getRunningExperimentsDashboard({ shopId }: { shopId: number }): Promise<RunningDashboard> {
    const url = `${this.serviceBaseUri}/${shopId}/experiments/running-dashboard`;
    const response = await this.httpService.get({ url });
    return (response.data ?? {}) as RunningDashboard;
  }
}

export const runningDashboardService = new RunningDashboardService();
